document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.swatch-item').forEach(function (item) {
    item.addEventListener('click', function () {
      const card = item.closest('.product-card, [class*="product-card"]');
      if (!card) return;

      const img = card.querySelector('img.product-card__image, .card__image img, img[class*="product"]');
      const variantImg = item.querySelector('.swatch')?.dataset?.variantImg;

      if (img && variantImg) {
        img.src = variantImg;
        img.srcset = variantImg;
      }
    });
  });
});
